import axios from "axios";
import React, { useState } from "react";

const ClientProfile = ({ userDetails }) => {
  const [responseMessage, setResponseMessage] = useState(false);
  const [formData, setFormData] = useState({
    id: userDetails.id,
    name: userDetails.name || "",
    mobile: userDetails.mobile || "",
    address: userDetails.address || "",
    category: userDetails.category || "",
    client_id: userDetails.client_id || "",
    actual_parent_id: userDetails.actual_parent_id || "",
    pan_no: userDetails.pan_no || "",
    date_of_b: userDetails.date_of_b || "",
    father_name: userDetails.father_name || "",
    mother_name: userDetails.mother_name || "",
    acc_no: userDetails.acc_no || "",
    ifsc: userDetails.ifsc || "",
    email: userDetails.email || "",
    nom_name: userDetails.nom_name || "",
    nom_father: userDetails.nom_father || "",
    nom_add: userDetails.nom_add || "",
    nom_relate: userDetails.nom_relate || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // await axios.put("http://localhost:8094/api/update-profile", formData);
      await axios.put("https://api.swalokgroup.com/api/update-profile", formData);

      setResponseMessage("Profile Updated Successfully");
      setTimeout(() => {
        localStorage.removeItem("all_clients");
        setResponseMessage("");
      }, 1000);
    } catch (error) {
      setResponseMessage("Error while updating profile");
    }
  };

  return (
    <section className="py-5 px-4">
      <div className="sec-subheading">
        <hr />
        <span>Manage Profile</span>
        <hr />
      </div>
      <div className="profile-area-inner mt-4">
        <p className="profile-heading">My Profile</p>

        <form className="row g-3 py-4 px-4" onSubmit={handleSubmit}>
          <div className="col-4">
            <label htmlFor="name" className="text-muted">
              Name
            </label>
            <input
              type="text"
              className="form-input"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter full name"
              required
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="mobile" className="text-muted">
              Phone
            </label>
            <input
              type="tel"
              className="form-input"
              name="mobile"
              value={formData.mobile}
              disabled
              placeholder="Mobile number"
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="category" className="text-muted">
              Designation
            </label>
            <select
              className="form-input"
              name="category"
              value={formData.category}
              disabled
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value="Associate">Associate</option>
              <option value="Employee">Employee</option>
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="pan_no" className="text-muted">
              PAN Number
            </label>
            <input
              type="text"
              className="form-input"
              name="pan_no"
              value={formData.pan_no}
              onChange={handleChange}
              placeholder="Enter PAN number"
              disabled
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="client_id" className="text-muted">
              User ID
            </label>
            <input
              type="text"
              className="form-input"
              name="client_id"
              value={formData.client_id}
              disabled
              placeholder="Client ID"
            />
          </div>

          <div className="col-md-4">
            <label htmlFor="actual_parent_id" className="text-muted">
              Refer ID
            </label>
            <input
              type="text"
              className="form-input"
              name="actual_parent_id"
              value={formData.actual_parent_id}
              disabled
              placeholder="Refer ID"
            />
          </div>

          <div className="col-4">
            <label htmlFor="address" className="text-muted">
              Address
            </label>
            <input
              type="text"
              className="form-input"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter your address"
            />
          </div>

          <div className="col-4">
            <label htmlFor="father_name" className="text-muted">
              Father's Name
            </label>
            <input
              type="text"
              className="form-input"
              name="father_name"
              value={formData.father_name}
              onChange={handleChange}
              placeholder="Enter father's name"
            />
          </div>

          <div className="col-4">
            <label htmlFor="mother_name" className="text-muted">
              Mother's Name
            </label>
            <input
              type="text"
              className="form-input"
              name="mother_name"
              value={formData.mother_name}
              onChange={handleChange}
              placeholder="Enter mother's name"
            />
          </div>

          <div className="col-4">
            <label htmlFor="acc_no" className="text-muted">
              Bank Account Number
            </label>
            <input
              type="text"
              className="form-input"
              name="acc_no"
              value={formData.acc_no}
              onChange={handleChange}
              placeholder="Enter Bank Account Number"
            />
          </div>

          <div className="col-4">
            <label htmlFor="ifsc" className="text-muted">
              Bank IFSC Code
            </label>
            <input
              type="text"
              className="form-input"
              name="ifsc"
              value={formData.ifsc}
              onChange={handleChange}
              placeholder="Enter Bank IFSC Code"
            />
          </div>

          <div className="col-4">
            <label htmlFor="mother_name" className="text-muted">
              Account Holder Name
            </label>
            <input
              type="text"
              className="form-input"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Account Holder name"
              disabled
            />
          </div>

          <div className="col-4">
            <label htmlFor="email" className="text-muted">
              Email
            </label>
            <input
              type="email"
              className="form-input"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
            />
          </div>

          <div className="col-4">
            <label htmlFor="date_of_b" className="text-muted">
              Date of Birth
            </label>
            <input
              type="date"
              className="form-input"
              name="date_of_b"
              value={formData.date_of_b}
              onChange={handleChange}
              placeholder="Select date of birth"
              required
            />
          </div>

          <div className="col-4">
            <label htmlFor="nom_name" className="text-muted">
              Nominee Name
            </label>
            <input
              type="text"
              className="form-input"
              name="nom_name"
              value={formData.nom_name}
              onChange={handleChange}
              placeholder="Enter nominee's name"
            />
          </div>

          <div className="col-4">
            <label htmlFor="nom_father" className="text-muted">
              Nominee Father’s Name
            </label>
            <input
              type="text"
              className="form-input"
              name="nom_father"
              value={formData.nom_father}
              onChange={handleChange}
              placeholder="Enter nominee's father's name"
            />
          </div>

          <div className="col-4">
            <label htmlFor="nom_add" className="text-muted">
              Nominee Address
            </label>
            <input
              type="text"
              className="form-input"
              name="nom_add"
              value={formData.nom_add}
              onChange={handleChange}
              placeholder="Enter nominee's address"
            />
          </div>

          <div className="col-4">
            <label htmlFor="nom_relate" className="text-muted">
              Nominee Relationship
            </label>
            <input
              type="text"
              className="form-input"
              name="nom_relate"
              value={formData.nom_relate}
              onChange={handleChange}
              placeholder="Enter relationship with nominee"
            />
          </div>

          <div className="col-12 my-4 text-end">
            <button type="submit" className="admin-btn py-2 px-3 rounded">
              Update Profile
            </button>
          </div>
        </form>

        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ClientProfile;
